import * as React from 'react'

import './LiveScoreSubtitleViewStyles.scss';
import useTranslation from '../../hooks/useTranslation';

const LiveScoreSubtitleView = (props:any) => {
    // FIXME is this ok? Do we need an effect hook?
    const pointflagStaticText = useTranslation(props.pointflagStaticTextKey);
    const pointflagSetText = useTranslation('VideoLiveScore_pointflag_set');
    const pointflagGameText = useTranslation('VideoLiveScore_pointflag_game');
    const pointflagPointText = useTranslation('VideoLiveScore_pointflag_point');

    if(props.pointflagStaticTextKey) {
        return (
            <div className="liveScoreSubtitleView">
                <span className="pointflagtranslation">{pointflagStaticText} {props.pointflagSuffix}</span>
            </div>
        )
    }else {
        return (
            <div className="liveScoreSubtitleView">
                <span className="set">{pointflagSetText} {props.period}</span>, 
                <span className="game">{pointflagGameText} {props.nthGameCounterOfSet}</span>, 
                <span className="point">{pointflagPointText} {props.nthPointCounter}</span>
            </div>
        )
    }
}

export default LiveScoreSubtitleView;
